export enum CreatorType {
  User = 'USER',
  Manager = 'MANAGER',
  System = 'SYSTEM',
  External = 'EXTERNAL',
}
